import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PropTypes from 'prop-types';

/**
 * Button Component
 * @param {*} props - Object
 */
export const CarauselComp = props => {
  const { settings, carousalRef } = props;

  /**
   * On Key Press Handler
   * @param {*} evt - Event Object
   */
  return (
    <Slider {...settings} ref={carousalRef}>
      {props.children}
    </Slider>
  );
};

CarauselComp.propTypes = {
  settings: PropTypes.object.isRequired,
  carousalRef: PropTypes.object,
};

CarauselComp.defaultProps = {
  settings: null,
  carousalRef: null,
};

export default CarauselComp;
